export default "__VITE_ASSET__CBa144n2__"